import React, { Component } from "react";

class FooterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this.updateIsMobile();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.updateIsMobile);
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateIsMobile);
    }
  }

  updateIsMobile = () => {
    if (typeof window === "undefined") return;

    const byWidth = window.innerWidth <= 768; // tweak breakpoint if you want
    const byUA =
      typeof navigator !== "undefined" &&
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    this.setState({ isMobile: byWidth || byUA });
  };

  render() {
    const { isMobile } = this.state;

    const APP_STORE_URL =
      "https://apps.apple.com/us/app/interview-dojo/id6755057417";
    const PLAY_STORE_URL =
      "https://play.google.com/store/apps/details?id=com.rabin.interviewdojo&pcampaignid=web_share";

    const APP_STORE_BADGE =
      "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";
    const PLAY_STORE_BADGE =
      "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";

    const LINKEDIN_URL =
      "https://www.linkedin.com/company/tech-venture-llc/?viewAsMember=true";
    const FACEBOOK_URL = "https://www.facebook.com/IshaniTechNepal";

    // common box so both badges look the same size
    const badgeBoxStyle = {
      width: 160,
      height: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const badgeImgStyle = {
      maxWidth: "100%",
      maxHeight: "100%",
      display: "block",
    };

    return (
      <footer
        className="page-footer font-small mdb-color lighten-1 pt-1 bg-secondary"
        style={{ position: "relative" }}
      >
        <div className="text-center text-md-start">
          <div className="container-fluid bg-light">
          <div className="row">
            {/* ====== Mobile-only App Store / Google Play badges ====== */}
            {isMobile && (
              <div className="col-12 text-center my-3">
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <a
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download Interview Dojo on the App Store"
                  >
                    <div style={badgeBoxStyle}>
                      <img
                        src={APP_STORE_BADGE}
                        alt="Download on the App Store"
                        style={badgeImgStyle}
                        loading="lazy"
                      />
                    </div>
                  </a>

                  <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get Interview Dojo on Google Play"
                  >
                    <div style={badgeBoxStyle}>
                      <img
                        src={PLAY_STORE_BADGE}
                        alt="Get it on Google Play"
                        style={badgeImgStyle}
                        loading="lazy"
                      />
                    </div>
                  </a>
                </div>
              </div>
            )}
            {/* ======================================================= */}

            <div className="col-md-4 col-lg-3 me-auto my-md-4 my-0 mt-4 mb-1 p-5">
              <h5 className="fw-bold text-uppercase mb-4">
                Thank You!
              </h5>
              <p>
                Your comments and complements are always the inspiration that
                keeps us motivated.
              </p>
            </div>

            <hr className="clearfix w-100 d-md-none" />
            <div className="col-md-2 col-lg-2 mx-auto my-md-4 my-0 mt-4 mb-1">
              <h5 className="fw-bold text-uppercase mb-4">About</h5>

              <ul className="list-unstyled">
                <li>
                  <p>
                    <a href="/projects">PROJECTS</a>
                  </p>
                </li>
                <li>
                  <p>
                    <a href="/home">ABOUT US</a>
                  </p>
                </li>
                <li>
                  <p>
                    <a href="/blogs">BLOG</a>
                  </p>
                </li>
                <li>
                  <p>
                    <a href="/badges">AWARDS</a>
                  </p>
                </li>
              </ul>
            </div>

            <hr className="clearfix w-100 d-md-none" />
            <div className="col-md-4 col-lg-3 mx-auto my-md-4 my-0 mt-4 mb-1">
              <h5 className="fw-bold text-uppercase mb-4">Address</h5>

              <ul className="list-unstyled">
                <li>
                  <p>
                    <i className="fas fa-home me-3"></i> Sterling, Virginia,
                    20166, US
                  </p>
                </li>
                <li>
                  <p>
                    <i className="fas fa-envelope me-3"></i>{" "}
                    info@techventurellc.com
                  </p>
                </li>
                <li>
                  <p>
                    <i className="fas fa-phone me-3"></i> 641 451 3463
                  </p>
                </li>
                <li>
                  <p>
                    <i className="fas fa-print me-3"></i> 641 451 3463
                  </p>
                </li>
              </ul>
            </div>

            <hr className="clearfix w-1 d-md-none" />
            <div className="col-md-2 col-lg-2 text-center mx-auto my-4">
              <h5 className="fw-bold text-uppercase mb-4">Follow Us</h5>

              {/* Facebook */}
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                type="button"
                className="btn-floating btn-li p-3"
                aria-label="Follow us on Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              {/* LinkedIn */}
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                type="button"
                className="btn-floating btn-li p-3"
                aria-label="Follow us on LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
          </div>
        </div>

        <div
          className="footer-copyright text-center py-3 text-light"
          style={{ position: "relative" }}
        >
          © 2022 Copyright:
          <a href="https://interviewdojo.dev/" className="text-light">
            {" "}
            interviewdojo.dev
          </a>
        </div>
      </footer>
    );
  }
}

export default FooterComponent;
